import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { EnglishToPersian } from "numeral-convert";
import { toFarsiNumber } from "../../cudtom-hooks/en-to-persian";
import FileDownload from "js-file-download";

const config = {
  headers: { Authorization: `Token ${localStorage.getItem("token")}` },
};
export const getNomadHistory = createAsyncThunk(
  "commonStates/getNomadHistory",
  async ({ nomad_id, page }) => {
    console.log("test", page);
    let historyArray = [];
    await axios
      .get(
        `https://api.khedmatashayer-kj.ir/v1/nomad/tanker-request/${page}?=&nomad_id=${nomad_id}`,
        config,
      )
      .then((res) => {
        res.data.forEach((item) => {
          let deliverDate, deliverTime;
          if (item.nomad_confirmed_at) {
            deliverDate = new Date(item.nomad_confirmed_at).toLocaleDateString(
              "fa-IR",
            );
            deliverTime = EnglishToPersian(item.nomad_confirmed_at.slice(11));
          }
          let registerDate = new Date(item.created_at).toLocaleDateString(
            "fa-IR",
          );
          historyArray = [
            ...historyArray,
            [
              toFarsiNumber(item.cost),
              toFarsiNumber(item.water_volume),
              deliverTime ?? "-",
              deliverDate ?? "-",
              item.driver?.name ?? "-",
              registerDate,
              toFarsiNumber(item.region),
              toFarsiNumber(item.tanker_request_id),
              item.water_type === 1 ? "آب شرب" : "آب دام",
            ],
          ];
        });
      })
      .catch((e) => {
        console.log("error", e);
        alert("خطا در برقراری ارتباط با سرور");
      });
    return historyArray;
  },
);
export const  getNomadInsurance = createAsyncThunk(
  "commonStates/getNomadInsurance",
  async ({ nomad_id }) => {
    let insuranceArray = [];
    try {
      const response = await axios.get(
        `https://api.khedmatashayer-kj.ir/v1/nomad/insurance?nomad_id=${nomad_id}`,
        config,
      );
      response.data.forEach((item) => {
        const expiryDate = new Date(item.expiry_date).toLocaleDateString("fa-IR");
        const createdDate = new Date(item.created_at).toLocaleDateString("fa-IR");
        insuranceArray.push({
          id: item.insurance_id,
          expiry: expiryDate,
          imageUrl: item.image ? `https://api.khedmatashayer-kj.ir${item.image}` : null,
          created: createdDate,
        });
      });
    } catch (e) {
      console.log("error", e);
      alert("خطا در برقراری ارتباط با سرور");
    }
    return insuranceArray;
  },
);
export const getCities = createAsyncThunk(
  "commonStates/getCities",
  async () => {
    let allCities = [];
    await axios
      .get("https://api.khedmatashayer-kj.ir/v1/city?province_id=1", config)
      .then((res) => {
        allCities = res.data;
      })
      .catch(() => {
        alert("خطا در برقراری ارتباط با سرور");
      });
    return allCities;
  },
);

export const getExcel = createAsyncThunk(
  "commonStates/getExcel",
  async (data) => {
    console.log("teststs");
    //This is using for three parts
    axios
      .post("https://api.khedmatashayer-kj.ir/v1/report/excel", data, {
        ...config,
        responseType: "blob",
      })
      .then(async (res) => {
        console.log("headers:", res.headers);
        console.log("size:", res.data.size);

        // 👇 تبدیل blob به متن
        const text = await res.data.text();
        console.log("blob text:", text);

        FileDownload(res.data, "report.xlsx");
      })
      .catch(async (e) => {
        if (e.response?.data) {
          const errorText = await e.response.data.text();
          console.log("error blob:", errorText);
        }
        console.log(e);
      });
  },
);

const commonStates = createSlice({
  name: "commonStates",
  initialState: {
    isPending: false,
    callApi: false,
    registerBtnType: "",
    passwordFormServerError: "",
    showForm: false,
    showEditForm: false,
    showHistory: false,
    showInsurance: false,

    historyArray: [],
    allCities: [],
    currentPage: 1,
  },
  reducers: {
    updatePending: (state, action) => {
      state.isPending = action.payload;
    },
    callApiAgain: (state, action) => {
      state.callApi = action.payload;
    },
    changeRegisterBtnType: (state, action) => {
      state.registerBtnType = action.payload;
    },
    setPasswordFormServerError: (state, action) => {
      state.passwordFormServerError = action.payload;
    },
    showPopUp: (state, action) => {
      let type = action.payload.type;
      let value = action.payload.value;
      switch (type) {
        case "showForm":
          state.showForm = value;
          break;
        case "showEditForm":
          state.showEditForm = value;
          break;
        case "showHistory":
          state.showHistory = value;
          break;
        case "showInsurance":
          state.showInsurance = value;
          break;
        default:
          throw Error("Not valid");
      }
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getNomadHistory.fulfilled, (state, action) => {
        state.historyArray = action.payload;
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.allCities = action.payload;
      });
  },
});

export const {
  updatePending,
  showPopUp,
  callApiAgain,
  changeRegisterBtnType,
  setPasswordFormServerError,
  setCurrentPage,
} = commonStates.actions;
export const selectIsPending = (state) => state.commonStates.isPending;
export const selectCallApi = (state) => state.commonStates.callApi;
export const selectShowForm = (state) => state.commonStates.showForm;
export const selectShowEditForm = (state) => state.commonStates.showEditForm;
export const selectShowHistory = (state) => state.commonStates.showHistory;
export const selectShowInsurance = (state) => state.commonStates.showInsurance;

export const selectRegisterBtnType = (state) =>
  state.commonStates.registerBtnType;
export const selectNomadHistoryArray = (state) =>
  state.commonStates.historyArray;
export const selectPasswordFormServerError = (state) =>
  state.commonStates.passwordFormServerError;
export const selectAllCities = (state) => state.commonStates.allCities;

export default commonStates.reducer;
export const selectCurrentPage = (state) => state.commonStates.currentPage;
